import {
  Box,
  Button,
  Typography,
  useTheme
} from '@mui/material';
import React, { useState } from 'react';
import { SaveCommentForm } from 'modules/components/layer12';
import { LogEvent } from 'modules/components/layer05';
import * as ds from './dataService';


export type ModalCommentSectionProps = {
  logName?: string;
  taskId: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ModalCommentSectionProps) => {
  const theme = useTheme();
  const [
    isEdit,
    setIsEdit
  ] = useState(false);

  const { data } = ds.useQuery(props.taskId ?? '');

  return (
    <Box
      display='flex'
      width='35.75rem'
      flexDirection='column'
      bgcolor={theme.palette.secondary.light}
      justifyContent='stretch'
      rowGap='1.5rem'
    >
      {
        isEdit && props.taskId !== ''
          ? (
            <Box>
              <SaveCommentForm.FC
                id=''
                taskId={props.taskId ?? ''}
                handleClose={() => setIsEdit(() => false)}
              />
            </Box>
          )
          : (
            <Button
              onClick={() => {
                setIsEdit(() => true);
              }}
              variant='contained'
            >
              Add Comment
            </Button>
          )
      }

      <Typography
        variant='activityHeader'
      >
        {props.logName ?? 'Event Log'}
      </Typography>

      <Box
        paddingTop='.5rem'
        display='flex'
        flexDirection='column'
        overflow='auto'
      >
        {/* COMMENT */}
        {data.map((node, i) => (
          <LogEvent.FC
            createdAt={node.createdAt}
            description={node.description}
            id={node.id}
            personName={node.personName}
            key={i}
          />
        ))}
      </Box>
    </Box>
  );
};
